import React from 'react';
import { enumValue } from '~/util';
import { usePatientService } from '~/services';
import { Notes } from '../Notes';

interface FocGapNotesProps {
    entityId: number;
    patientId: number;
}
export function FocGapNotes({ entityId, patientId }: FocGapNotesProps) {
    const { updateFocGap } = usePatientService();

    async function addNote(note: NewNoteType) {
        await updateFocGap(entityId, patientId, note);
    }

    return (
        <Notes
            addNote={addNote}
            entityId={entityId}
            noteEntity="foc_gap.id"
            noteType={enumValue(['note', 'type', 'FOC Gap Note']) as number}
        />
    );
}
